import styled from 'styled-components';
import tsfont from '../../../../tsfont.json';
import { minWidth } from 'helpers/buildMediaQueries';
import {
  colorsVariables,
  flexItemsCentered,
  fontVariables,
  gutterVariables
} from '@trustedshops/tps-seo-shared-frontend-react-components';
import {
  labelAndIconInGridStyles,
  labelNoWrapStyles
} from '../LabelAndIconInGrid.styles';

const TEXT_TO_ICON_COLUMN_GAP = '4px';

export const Sorting = styled.div`
  ${minWidth(
    'xl',
    `display: flex;
    column-gap: ${TEXT_TO_ICON_COLUMN_GAP};`
  )}
`;

export const SortingOpener = styled.div`
  font-size: ${fontVariables.SIZE_TEXT_M};
  line-height: ${fontVariables.LINE_HEIGHT_L};
  padding-top: ${gutterVariables.GUTTER_HALF};
  ${labelAndIconInGridStyles};
  justify-content: space-between;
  cursor: pointer;
  position: relative;
  white-space: nowrap;

  span:first-child,
  strong:first-child {
    ${labelNoWrapStyles}
  }

  &:focus {
    outline: 0;
  }

  ${tsfont.templateOptions.baseSelector}${tsfont.templateOptions
    .baseSelector}-icon-arrow-chevron-down {
    transform: rotate(-90deg);
    transition: transform 300ms ease-in-out 0ms;
    margin-left: ${gutterVariables.GUTTER_ONE_QUARTER};
  }

  &.dropdownOpen
    ${tsfont.templateOptions.baseSelector}${tsfont.templateOptions
      .baseSelector}-icon-arrow-chevron-down {
    transform: rotate(180deg);
  }

  ${minWidth(
    'xl',
    `
      display: inline-flex;
      font-size: ${fontVariables.SIZE_TEXT};
      line-height: 28px;
      padding: 0;
      ${tsfont.templateOptions.baseSelector}${tsfont.templateOptions.baseSelector}-icon-arrow-chevron-down {
        transform: rotate(0deg);
      }
    `
  )}

  ul {
    left: auto;
    right: 0;
    margin-top: 6px;

    li {
      white-space: nowrap;
      text-align: left;
      padding-left: ${gutterVariables.GUTTER};
    }
  }
`;

export const SortingModalSelector = styled.div`
  ${flexItemsCentered};
  column-gap: ${TEXT_TO_ICON_COLUMN_GAP};
`;

export const SortingItem = styled.li`
  list-style-type: none;
  font-size: ${fontVariables.SIZE_TEXT_M};
  line-height: 44px;
  position: relative;
  cursor: pointer;

  &:last-child {
    margin-bottom: ${gutterVariables.GUTTER};
    ${minWidth('xl', 'margin-bottom: 0;')}
  }

  &.active {
    color: ${colorsVariables.BLUE_700};
    ${minWidth('xl', 'color: inherit;')};
    font-weight: ${fontVariables.FONT_WEIGHT_BOLD};
    padding-right: 28px;

    ${tsfont.templateOptions.baseSelector}${tsfont.templateOptions
      .baseSelector}-icon-feedback-check {
      position: absolute;
      right: 0;
      top: ${gutterVariables.GUTTER_HALF};
      color: ${colorsVariables.GREEN_500};
      ${minWidth('xl', 'display: none')}
    }
  }
`;
